import { sharedProperty, useSharedState } from '../../../hooks';
import ServiceModel from '../../../data/entities/booking/ServiceModel';
import { BookingModel } from '../../../data/entities/booking/BookingModel';
import { BookingEventModel } from '../../../data/entities/booking/BookingEventModel';
import { trackServiceAdded, trackServiceSelected } from '../../../utils';

export const useServiceSelection = (booking: sharedProperty<BookingModel>) => {
  const showBookServiceState = useSharedState(false);
  const bookServiceState = useSharedState<ServiceModel>({} as ServiceModel);

  const addBookingEvent = (bookingEvent: BookingEventModel, price?: number) => {
    trackServiceAdded(bookingEvent, price);
    booking.setter({
      ...booking.value,
      bookingEvents: [...booking.value.bookingEvents, bookingEvent],
    });
    showBookServiceState.setter(false);
  };

  const handleServiceClick = (service: ServiceModel) => {
    trackServiceSelected(service);
    bookServiceState.setter(service);
    showBookServiceState.setter(true);
  };

  return {
    showBookServiceState,
    bookServiceState,
    addBookingEvent,
    handleServiceClick,
  };
};
